// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dialog":"Dialog__dialog--15FTn","icon":"Dialog__icon--3JHkl","glass":"Dialog__glass--1STH1","chrome":"Dialog__chrome--1EUlH","content":"Dialog__content--3XtNk"};